import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

const LS_KEY = 'rw_cookie_consent';

export const CookiePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(LS_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(LS_KEY, 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(LS_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4" data-testid="cookie-popup">
      <div className="max-w-3xl mx-auto bg-[#111] border border-[#2A2A2A] rounded-2xl p-5 shadow-[0_-4px_40px_rgba(0,0,0,0.6)]">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-9 h-9 rounded-xl bg-[#00FF00]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <Cookie className="w-4 h-4 text-[#00FF00]" />
            </div>
            <p className="text-xs text-slate-400 leading-relaxed">
              Ce site utilise des cookies pour améliorer votre expérience.
              En continuant, vous acceptez notre{' '}
              <Link to="/politique-cookies" className="text-[#00FF00] underline underline-offset-2 hover:text-[#00CC00]">
                politique de cookies
              </Link>.
            </p>
          </div>
          <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
            <Button
              onClick={refuse}
              variant="outline"
              className="border-[#2A2A2A] text-slate-400 hover:bg-[#1A1A1A] text-xs px-5 flex-1 sm:flex-none"
              data-testid="cookie-refuse-btn"
            >
              Refuser
            </Button>
            <Button
              onClick={accept}
              className="bg-[#00FF00] text-black hover:bg-[#00CC00] font-bold text-xs px-5 flex-1 sm:flex-none"
              data-testid="cookie-accept-btn"
            >
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
